import { APIMethod, fetchData } from "@client";

export async function setCompanyDetailsQuery(data) {
  await fetchData("/company", APIMethod.POST, { data, removeEmptyKeys: true });
}
